import { render, staticRenderFns } from "./AppDoughnutReport.vue?vue&type=template&id=0c50c80c&"
import script from "./AppDoughnutReport.vue?vue&type=script&lang=js&"
export * from "./AppDoughnutReport.vue?vue&type=script&lang=js&"
import style0 from "./AppDoughnutReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports